import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import * as types from "../../constants/actionTypes";
import { messages, success, deleteData } from "../../components/messageBox"
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST } from "../../service/api";
import { Header } from '../../constants/headers';
import { setLoader } from "./actions";
import moment from 'moment';


const getStateDashboard = state => state.DashboardApotek;

export function* listReservasiResepObat(params) {
    try {
        yield put(setLoader(true));

        let stateDashboard = yield select(getStateDashboard)
        const _id = JSON.parse(localStorage.getItem('UserData')).f_id_klinik;
        
        if(params.value == 'all'){
            const _body = {
                "id": _id,
                "chooseDate": moment().format("YYYY-MM-DD"),
            }
            const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DASHBARD_APOTEK_LIST_RESERVASI_RESEP_OBAT_POST, _body, { headers: Header()});
    
            if(response.acknowledge == 1){
                yield put({ type: types.DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_ALL_SUCCESS, value: response.data})
            }else{
                messages("Error", "Gagal memuat data", "error", false, false);
            }
        }else if(params.value > 0){
            //detail
        }else{
            messages("Error", "Gagal memuat data", "error", false, false);
        }

        yield put(setLoader(false));
    } catch (error) {
        yield put(setLoader(false));
    }
}

export function* getDetailReservasiApotek(params) {
    try {
        yield put(setLoader(true));

        let stateDashboard = yield select(getStateDashboard)
        const _id = JSON.parse(localStorage.getItem('UserData')).f_id_klinik;
        
        if(params.value){
            const _body = {
                "id": params.value,
            }
            const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DASHBARD_APOTEK_DETAIL_RESERVASI_RESEP_OBAT_POST, _body, { headers: Header()});
    
            if(response.acknowledge == 1){
                yield put({ type: types.DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_DETAIL_SUCCESS, value: response.data})
            }else{
                messages("Error", "Gagal memuat data", "error", false, false);
            }
        }else{
            messages("Error", "Gagal memuat data", "error", false, false);
        }

        yield put(setLoader(false));
    } catch (error) {
        yield put(setLoader(false));
    }
}

export function* finishResepObat(params) {
    try {
        yield put(setLoader(true));

        const _body = {
            "id": params.value,
        }

        const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DASHBARD_APOTEK_FINISH_RESEP_OBAT, _body, { headers: Header()});

        if(response.acknowledge == 1){
            messages("Berhasil", response.message, "success", false, params.history);
        }else{
            messages("Error", "Gagal memuat data", "error", false, false);
        }
        yield put(setLoader(false));
    } catch (error) {
        yield put(setLoader(false));
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(types.DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT, listReservasiResepObat),
        takeLatest(types.DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_BY_ID, getDetailReservasiApotek),
        takeLatest(types.DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_FINISH, finishResepObat),
    ]);
}

